import { useRuntimeVariables } from 'app-kit'
import { Thumbnail } from 'components/table/utility/Thumbnail'
import DOMPurify from 'dompurify'
import { getAsset3DModelImageURL } from 'features/assetDatabase/components/assetImage/assetImageUtils'
import React, { useState } from 'react'

export const Asset3DModelImage: React.FC<{
  assetModelType: string
  showThumbnail?: boolean
}> = ({ assetModelType, showThumbnail = false }) => {
  const [imageError, setImageError] = useState(false)
  const { GECKO_ASSETS_URL } = useRuntimeVariables()
  const sanitizedURL = DOMPurify.sanitize(GECKO_ASSETS_URL)

  const assetImage3DURL = getAsset3DModelImageURL(assetModelType, sanitizedURL)

  return (
    <>
      {!imageError && assetImage3DURL ? (
        <img
          src={assetImage3DURL}
          alt='3D model image of the asset'
          onError={() => setImageError(true)}
        />
      ) : !showThumbnail ? (
        <Thumbnail />
      ) : null}
    </>
  )
}
